import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

(function() {
  try {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('token=') === -1) return;
    var queryIndex = hash.indexOf('?');
    if (queryIndex === -1) return;
    var queryString = hash.slice(queryIndex + 1);
    var params = new URLSearchParams(queryString);
    var token = params.get('token');
    if (!token) return;
    for (var key of Array.from(params.keys())) {
      var value = params.get(key);
      if (value !== null && value !== undefined && value !== 'undefined' && value !== 'null') {
        if (key === 'accountId') {
          var accountIdNum = Number(value);
          if (accountIdNum > 0) {
            sessionStorage.setItem(key, accountIdNum.toString());
          }
        } else {
          sessionStorage.setItem(key, value);
        }
      }
    }
    var cleanHash = hash.split('?')[0];
    window.history.replaceState(null, '', cleanHash);
  } catch (e) {
    console.error('Landing bootstrap failed:', e);
  }
})();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  useJit: true,
  preserveWhitespaces: true
})
  .catch(err => console.log(err));
